export const messages = {
  en: {
    maintainanceTaskDetailView: {
      title: 'Maintenance Detail',
      basicInfo: 'Basic Information',
      photosTitle: 'Maintenance Photos',
      descriptionTitle: 'Maintenance Description',
      noPhotos: 'No photos available',
      noDescription: 'No description',
      back: 'Back',
      fields: {
        taskDetailId: 'ID',
        machineName: 'Equipment Name',
        planUserName: 'Planned Maintainer',
        planTime: 'Planned Maintenance Time',
        actUserName: 'Actual Maintainer',
        inspectionTime: 'Actual Maintenance Time',
        stateName: 'Status',
        planName: 'Plan',
        standardName: 'Maintenance Standard'
      },
      fetchError: 'Failed to load maintenance detail'
    }
  },
  zh: {
    maintainanceTaskDetailView: {
      title: '保养详情',
      basicInfo: '基本信息',
      photosTitle: '保养图片',
      descriptionTitle: '保养说明',
      noPhotos: '暂无保养图片',
      noDescription: '暂无保养说明',
      back: '返回',
      fields: {
        taskDetailId: '编码',
        machineName: '设备名称',
        planUserName: '计划保养人',
        planTime: '计划保养时间',
        actUserName: '实际保养人',
        inspectionTime: '实际保养时间',
        stateName: '状态',
        planName: '计划',
        standardName: '保养标准'
      },
      fetchError: '获取保养详情失败'
}
  },
  'zh-TW': {
    maintainanceTaskDetailView: {
      title: '保養詳情',
      basicInfo: '基本信息',
      photosTitle: '保養圖片',
      descriptionTitle: '保養說明',
      noPhotos: '暫無保養圖片',
      noDescription: '暫無保養說明',
      back: '返回',
      fields: {
        taskDetailId: '編號',
        machineName: '設備名稱',
        planUserName: '計劃保養人',
        planTime: '計劃保養時間',
        actUserName: '實際保養人',
        inspectionTime: '實際保養時間',
        stateName: '狀態',
        planName: '計劃',
        standardName: '保養標準'
      },
      fetchError: '獲取保養詳情失敗'
    }
  }
};